export class RegistrationDataModel {
    Title: string;

    FirstName: string;

    MiddleName: string;

    LastName: string;

    AlternateNo: string;

    AlternateValidity: string;

    Nationality: string;

    Employer: string;

    Occupation: string;

    PassportNo: string;

    PassportValidity: string;  

    HouseNo: string;

    Area: string;

    Flat: string;

    ZipCode: string;

    Town: string;

    BloodGroup: string;

    Religion: string;

    FatherHusbandName: string;

    MaritalStatus: string;

    Dob: string;

    Gender: string;

    Telephone: string;

    MobileNo: string;

    Email: string;

    EmergencyContactPerson: string;

    Relation: string;

    EmergenceContactNo: string;

    Note: string;

    HospitalNo: string;

    PoBox: string;

    AlternateType: string;

	IsDateEnteredManually : boolean;

	ProviderCode : string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/Registration/RegistrationDataModel.ts